import { axiosV2, getError, getResponse, settings } from '../../helpers/UtilsHelper';

const { app } = settings;
const { backend } = app;
const { urls } = backend;

export const RateService = {
    /**
     * Get all rates
     * @param {Object} params
     * @param {string} params.token
     * @param {Object} params.dataObj
     * @param {string} params.subMethod
     * @returns {Promise<Object>}
     */
    getAll: async ({
        token = '',
        dataObj = {},
        subMethod = ''
    } = {}) => {
        const currentMethod = 'RateService.getAll';
        let response = getResponse({ type: 0 });
        try {
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.post({
                url: `${urls?.url}${urls?.apiV1}${urls?.rates}/`,
                data: dataObj,
                headers,
                subMethod: currentMethod
            });
            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    },

    /**
     * Save or Update a rate
     * @param {Object} params
     * @param {Object} params.rate - Rate data object.
     * @param {string} params.token - Bearer token.
     * @param {number} params.processType - 0: Add, 1: Edit.
     * @param {string} [params.subMethod=''] - Sub-method for traceability.
     * @returns {Promise<Object>}
     */
    save: async ({
        rate = {},
        token = '',
        processType = 0,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'RateService.save';
        let response = getResponse({ type: 0 });
        try {
            const headers = { authorization: `bearer ${token}` };
            const url = `${urls?.url}${urls?.apiV1}${urls?.rates}/${processType === 0 ? '' : rate?.id}`;

            response = await axiosV2?.post({
                url,
                data: rate,
                headers,
                subMethod: currentMethod
            });
            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    },

    /**
     * Save a list of rates (batch apply to all users)
     * @param {Object} params
     * @param {Array} params.rateList - Array of rate objects to register.
     * @param {string} params.token - Bearer token.
     * @param {string} [params.subMethod=''] - Sub-method for traceability.
     * @returns {Promise<Object>}
     */
    saveList: async ({
        rateList = [],
        token = '',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'RateService.saveList';
        let response = getResponse({ type: 0 });
        try {
            const headers = { authorization: `bearer ${token}` };
            const dataObj = {
                coditionals: [],
                ordersBy: [],
                method: backend?.methods?.rates?.addList,
                data: rateList,
            };

            response = await axiosV2?.post({
                url: `${urls?.url}${urls?.apiV1}${urls?.rates}/`,
                data: dataObj,
                headers,
                subMethod: currentMethod
            });
            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    },

    /**
     * Get rate by Id
     * @param {Object} params
     * @param {string} params.id
     * @param {string} params.token
     * @param {string} params.subMethod
     * @returns {Promise<Object>}
     */
    getById: async ({
        id = '',
        token = '',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'RateService.getById';
        let response = getResponse({ type: 0 });
        try {
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.get({
                url: `${urls?.url}${urls?.apiV1}${urls?.rates}/${id}`,
                headers,
                subMethod: currentMethod
            });
            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    },

    /**
     * Delete a rate by Id
     * @param {Object} params
     * @param {string} params.id
     * @param {string} params.token
     * @param {string} params.subMethod
     * @returns {Promise<Object>}
     */
    deleteById: async ({
        id = '',
        token = '',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'RateService.deleteById';
        let response = getResponse({ type: 0 });
        try {
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.delete({
                url: `${urls?.url}${urls?.apiV1}${urls?.rates}/${id}`,
                headers,
                subMethod: currentMethod
            });
            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    }
};
